module.exports = __webpack_public_path__ + "static/media/mountains-small-taggis.4a853639.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mountains-small-taggis.jpg
// module id = 92
// module chunks = 3